import {useQuery} from "@tanstack/react-query";
import {useState} from "react";
import {useParams} from "react-router";
import LibraryService from "../../../../services/web/library-service.js";
import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import ModalAttaches from "../../../../components/modal/modal-attaches.jsx";
import SPdf from "../../../../components/icons/pdf.jsx";
import {FaFile} from "react-icons/fa";
import {imageExtensions} from "../utils/library-utils.js";

export default function LibraryDocumentView() {
    const { id } = useParams();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const { data, isLoading } = useQuery({
        queryKey: ["library-sentry-doc", id],
        queryFn: () => LibraryService.getDocById(id),
        enabled: !!id,
    });

    const getFileExtension = (file) => {
        const typeExtension = file.extension?.split("/").pop();

        return (typeExtension ?? file.name?.split(".").pop() ?? "").toLowerCase();
    };

    const openAttach = (file) => {
        const attachId = file.attachId ?? file.id;
        const extension = getFileExtension(file);
        const url = file.url ?? (extension === "pdf"
            ? LibraryService.openPDF(attachId)
            : LibraryService.downloadFile(attachId));

        setSelectedFile({
            ...file,
            attachId,
            extension,
            url,
        });
        setModalOpen(true);
    };

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>{data?.name ?? "Sentry Doc"}</Template.Title>
            </Template.Header>
            <Template.Body className="flex h-full min-h-0 flex-col space-y-2">
                <Card>
                    <Card.Header>
                        <Card.Title>Conteúdo</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {data?.description ? (
                            <div
                                className="
                                    min-h-96 rounded-md border border-zinc-200 bg-white px-6 py-4
                                    text-xs leading-9 text-zinc-700
                                    [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6
                                    [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6
                                    [&_li]:my-1
                                "
                                dangerouslySetInnerHTML={{__html: data.description}}
                            />
                        ) : (
                            <p className="text-sm text-zinc-400">
                                Este Sentry Doc não possui conteúdo.
                            </p>
                        )}
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header>
                        <Card.Title>Anexos</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {data?.attaches?.length ? (
                            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
                                {data.attaches.map((file, index) => {
                                    console.log(file)
                                    const attachId = file.attachId ?? file.id;
                                    const fileName = file.name ?? `Anexo ${index + 1}`;
                                    const extension = getFileExtension(file);
                                    const isImage = imageExtensions.includes(extension);
                                    const isPdf = extension === "application/pdf";

                                    return (
                                        <button
                                            key={attachId ?? index}
                                            type="button"
                                            onClick={() => openAttach(file)}
                                            title={`Visualizar ${fileName}`}
                                            className="cursor-pointer group min-w-0 overflow-hidden rounded-lg border border-zinc-200 bg-white text-left transition hover:border-blue-400 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <span className="flex h-32 items-center justify-center overflow-hidden bg-zinc-50">
                                                {isImage ? (
                                                    <img
                                                        src={file.url ?? LibraryService.downloadFile(attachId)}
                                                        alt={`Pré-visualização de ${fileName}`}
                                                        className="h-full w-full object-contain"
                                                    />
                                                ) : isPdf ? (
                                                    <SPdf size={64} className="text-red-600" aria-hidden="true" />
                                                ) : (
                                                    <FaFile size={52} className="text-zinc-400" aria-hidden="true" />
                                                )}
                                            </span>
                                            <span className="block truncate border-t border-zinc-200 px-3 py-2 text-sm text-zinc-700">
                                                {fileName}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        ) : (
                            <p className="text-sm text-zinc-400">
                                Este Sentry Doc não possui anexos.
                            </p>
                        )}
                    </Card.Body>
                </Card>
                <ModalAttaches
                    open={modalOpen}
                    setOpen={setModalOpen}
                    file={selectedFile}
                    title={selectedFile?.name ?? "Anexo"}
                />
            </Template.Body>
        </Template>
    );
}
